(() => {
  const BAR_SELECTOR = '[id$="__announcement_bar_EGpazV"]';
  const HEADER_SELECTOR = '.section-header';
  const observedElements = new Set();
  let animationFrame;

  const updatePositions = () => {
    animationFrame = undefined;
    const bars = [...document.querySelectorAll(BAR_SELECTOR)].filter(
      (bar) => getComputedStyle(bar).display !== 'none'
    );
    const stackHeight = bars.reduce((height, bar) => height + bar.getBoundingClientRect().height, 0);

    bars.forEach((bar) => {
      if (!observedElements.has(bar)) {
        observedElements.add(bar);
        resizeObserver.observe(bar);
      }
    });

    document.documentElement.style.setProperty('--as-announcement-stack-height', `${stackHeight}px`);
    document.documentElement.classList.toggle('as-sticky-announcements-ready', bars.length > 0);

    const header = document.querySelector(HEADER_SELECTOR);
    if (header && !observedElements.has(header)) {
      observedElements.add(header);
      resizeObserver.observe(header);
    }
  };

  const scheduleUpdate = () => {
    if (animationFrame) return;
    animationFrame = requestAnimationFrame(updatePositions);
  };

  const resizeObserver = new ResizeObserver(scheduleUpdate);
  const mutationObserver = new MutationObserver(scheduleUpdate);

  const initialize = () => {
    mutationObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
    scheduleUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
